import { useMemo } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { PublicConfig } from '../../../functions/src/shared';
import Footer from './components/Footer';
import Head from './components/Head/Head';
import { Logo } from './components/Logo';
import { MissingConfiguration } from './components/MissingConfiguration/MissingConfiguration';
import ScrollToTop from './components/ScrollToTop';
import WizardProvider from './contexts/WizardContext/WizardProvider';
import { usePublicConfig } from './firebase/hooks';
import { Routes } from './Routes';

export const App = () => {
  const publicConfig = usePublicConfig();

  const missingConfigurationKeys = useMemo(() => {
    const missingKeys: (keyof PublicConfig)[] = [];

    // Fallback is true
    const isPrivacyPolicyRequired = publicConfig.isPrivacyPolicyRequired ?? true;

    if (isPrivacyPolicyRequired && !publicConfig.privacyPolicyUrl) {
      missingKeys.push('privacyPolicyUrl');
    }
    return missingKeys;
  }, [publicConfig]);

  return (
    <div className="app-container">
      <Head />
      <WizardProvider>
        <BrowserRouter>
          <ScrollToTop />
          <Logo src={publicConfig.theme.logo} />
          {missingConfigurationKeys.length === 0 ? (
            <>
              <Routes />
              {publicConfig && <Footer />}
            </>
          ) : (
            <MissingConfiguration missingKeys={missingConfigurationKeys} />
          )}
        </BrowserRouter>
      </WizardProvider>
    </div>
  );
};
